import React from "react";

const Paragraph=(props)=>{
    return(
        <p className=" font-monospace" style={{color:"black", fontSize:"medium",fontFamily:"Crimson Text,serif"}}>{props.para}</p>
    )
}

export default Paragraph